export default {
    repair: {
        reset: {
            confirm: {
                query: "<span style='color:red'>{0} löschen?</span>",
                text : "<p>Mit dem Wechsel in den Status <b>{0}</b> wird der Bearbeitungsschritt <b>{1}</b> gelöscht.</p><p>Alle Dokumente, die über die Inbox importiert wurden, werden wieder in die Inbox verschoben.</p><p>Alle Dokumente, die direkt in das Ereignis importiert wurden, werden gelöscht.</p><p>Mit <b><span style='color:red'>JA</span></b> wird der Bearbeitungsschritt <b>{1}</b> gelöscht.</p>"
            }
        },

        modernization: {
            start: "Start der Maßnahme",
            end  : "Ende der Maßnahme",
            warranty: "Gewährleistung bis"
        },

        bid: {
            date: "Angebotsdatum",
            orderDate: "Auftragsdatum",
            deadlineDate: "Abgabefrist",
            document: {
                deletehint: "Dem Angebot sind noch Dokument zugeordnet. Falls diese nicht mehr bönitgt werden, bitte diese löschen, oder vom Ereignis lösen. ",
            },
            deadline: {
                begin: "Frist Beginn",
                end  : "Frist Ende"
            },
            execute: {
                begin: "Beginn der Arbeiten",
                end  : "Ende der Arbeiten"
            },
            changeToCollective: {
                query: "Sammelangebot erstellen?",
                text : "Bisher werden für jede Anlage separate Angebote erstellt. Mit <b>JA</b> werden Sammelangebote für alle Anlagen erstellt. Bei dieser Aktion gehen die bisher erfassten Daten verloren. Soll die Änderung nun durchgeführt werden?"
            },
            changeToSeparated: {
                query: "Einzelangebote erstellen?",
                text : "Bisher werden Sammelangebote für alle Anlagen erstellt. Mit <b>JA</b> werden Einzelangebote pro Anlage erstellt. Bei dieser Aktion gehen die bisher erfassten Daten verloren. Soll die Änderung nun durchgeführt werden?"
            },

            error: {
                "cost-without-price"   : "Kosten ohne Angebostspreis",
                "cost-price-difference": "Kosten ungleich Angebostspreis"
            },

            rules: {
                manufacturer: "Das ausführende Unternehmen wird bereits verwendet"
            },
            label: {
                favorite: "Favorit",
                email   : "Email Ansprechpartner",
                number  : "Angebotsnummer",
                measure : "Maßnahme gemäß Angebot",
            },
            query: {
                favorite: "Soll dieses Angebot der Favorit werden?"
            },
            name: {
                first        :"Ursprungsangebot",
                alternative_1:"Alternativangebot I",
                alternative_2:"Alternativangebot II",
                alternative_3:"Alternativangebot III",
                alternative_4:"Alternativangebot IV",
                alternative_5:"Alternativangebot V",
                alternative_6:"Alternativangebot VI",
                alternative_7:"Alternativangebot VII",
                alternative_8:"Alternativangebot VIII",
                alternative_9:"Alternativangebot IX"
            }
        },
    },
}